import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '@treezor/design-system';

import { useGetPasskey } from '../hooks/useGetPasskey';

export function Auth2FaAuthentication() {
  const { t } = useTranslation();

  const { isLoading, isDisabled, authenticate2FA } = useGetPasskey();

  useEffect(() => {
    if (!isDisabled) {
      authenticate2FA();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);

  return (
    <>
      <span className="typo-body-regular-paragraphLarge text-primary">
        {t('pages.auth.2fa.authenticatingDescription')}
      </span>
      {isLoading && <Loader />}
    </>
  );
}
